export default __webpack_public_path__ + "static/global-compliant-4841a326a6826dda9b99e8c8fefb35a6.svg";